import {
  TCommunityProcessingFilters,
  TCommunityProcessingFiltersFunc,
  TCommunityProcessingList,
  TCommunityProcessingParams,
  TCommunityProcessingRequestData
} from './types'
import { Table } from '../../../../components/Table'
import { useEffect, useRef, useState } from 'react'
import { DEFAULT_PAGE } from '../../../../components/Table/constants'
import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../components/Typography'
import { Button, BUTTON_TYPES } from '../../../../components/Button'
import { BTN_TXT, TOOLTIP } from '../../../../constants'
import { ReactComponent as Edit16 } from 'assets/svg/Edit16.svg'
import { Sorter } from '../../../../components/Sorter/Sorter'
import { SortOrder } from 'antd/es/table/interface'
import { Dropdown } from '../../../../components/Dropdown'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { Table as TableAntd } from 'antd'
const { Column, ColumnGroup } = TableAntd
import { ReactComponent as InfoIcon } from 'assets/svg/Information.svg'
import axios, { CancelTokenSource } from 'axios'
import { setLoading } from 'redux/store/common/slice'
import { useDispatch } from 'react-redux'
import { isTableHasParams } from 'helper/common'
import {
  fetchHSListOptions,
  fetchHSProcessingTable
} from 'features/Financials/api'
import { ReactComponent as Filter16 } from 'assets/svg/Filter16.svg'
import { ReactComponent as FilterApplied16 } from 'assets/svg/FilterApplied16.svg'
import './style.scss'
import { optionFormatter } from '../../../Contracts/helpers'
import cn from 'classnames'
import { detectIfEmpty } from './utils'
import { CheckboxProps } from 'antd/lib/checkbox/Checkbox'
import { EditModal } from './EditModal/EditModal'
import { TCommunityProcessingItem } from '../../types'

export const TableProcessing = ({ uuid, callback }) => {
  const dispatch = useDispatch()

  const [totalNumber, setTotalNumber] = useState(0)
  const [isEditOpen, setIsEditOpen] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedRows, setSelectedRows] = useState<TCommunityProcessingList[]>(
    []
  )

  const [tableData, setTableData] = useState<TCommunityProcessingItem[]>([])
  const [sortParams, setSortParams] =
    useState<TCommunityProcessingRequestData>()
  const [filters, setFilters] = useState<TCommunityProcessingFilters>({})
  const [firstLoad, setFirstLoad] = useState(true)
  const [pageInfo, setPageInfo] = useState({ ...DEFAULT_PAGE })

  const tableDataTokenRef = useRef<CancelTokenSource>()

  const getFirstData = () => {
    getTableData({ ...sortParams, ...filters, page: { ...DEFAULT_PAGE } })
  }

  useEffect(() => {
    getFirstData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return () => {
      if (tableDataTokenRef.current) {
        tableDataTokenRef.current.cancel()
      }
    }
  }, [])

  const getTableData = ({
    sortField,
    sortOrder,
    filters,
    page
  }: TCommunityProcessingRequestData) => {
    dispatch(setLoading(true))
    if (firstLoad) {
      setFirstLoad(false)
    }
    if (tableDataTokenRef.current) {
      tableDataTokenRef.current.cancel()
    }
    const params: TCommunityProcessingParams = { ...filters }
    if (sortField) {
      if (sortOrder) {
        params.ordering = `${sortOrder === 'descend' ? '-' : ''}${sortField}`
      }
      setSortParams({
        sortField,
        sortOrder
      })
    }
    const dataPage = page ? page : pageInfo
    params.limit = dataPage.pageSize
    params.offset = (dataPage.pageNumber - 1) * dataPage.pageSize
    tableDataTokenRef.current = axios.CancelToken.source()

    setTotalNumber(0)
    setTableData([])
    fetchHSProcessingTable(uuid as string, {
      cancelToken: tableDataTokenRef.current?.token,
      params
    })
      .then((resp) => {
        if (!resp.data?.results) {
          return
        }
        setTableData(
          resp.data.results.map((i) => ({
            ...i,
            key: i.uuid
          }))
        )
        setSelectedRowKeys([])
        setSelectedRows([])
        setTotalNumber(resp.data.count)
      })
      .finally(() => dispatch(setLoading(false)))
  }

  const applyFilters: TCommunityProcessingFiltersFunc = (
    field,
    appliedFilters
  ) => {
    const newFilters = { ...filters, [field]: appliedFilters }
    setFilters(newFilters)
    getTableData({ ...sortParams, filters: newFilters })
  }
  useEffect(() => {
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData[0]?.uuid as string])

  const handleTableChange = (pagination, _filters, sorter) => {
    const page = {
      pageNumber: pagination.current,
      pageSize: pagination.pageSize
    }
    getTableData({
      sortField: sorter.field,
      sortOrder: sorter.order,
      filters,
      page
    })
    setPageInfo(page)
  }
  const handleSelectRow = (selectedRowKeys, selectedRow) => {
    setSelectedRowKeys(selectedRowKeys)
    setSelectedRows(selectedRow)
  }

  const resetSelected = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
  }

  const handleChangePageSize = (pageSize) => {
    const page = {
      pageNumber: 1,
      pageSize
    }
    getTableData({
      ...sortParams,
      filters,
      page
    })
    setPageInfo(page)
  }

  return (
    <div className="community-processing-container table-wrapper mt-24 mb-24">
      <div className="table-wrapper__header">
        {!!selectedRowKeys.length ? (
          <Typography.Body1
            className="table-wrapper__select-title"
            weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
          >
            Selected {selectedRowKeys.length} of {totalNumber}
          </Typography.Body1>
        ) : (
          <Typography.Headline6
            className="table-wrapper__select-title"
            weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
          >
            Split fees
          </Typography.Headline6>
        )}
        {!!selectedRowKeys.length && (
          <div className="table-wrapper__header_buttons row gap-16">
            <Button
              onClick={resetSelected}
              type={BUTTON_TYPES.DEFAULT}
              upperCase
            >
              {BTN_TXT.CANCEL}
            </Button>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              onClick={() => setIsEditOpen(true)}
              icon={<Edit16 />}
              upperCase
              className="table-wrapper__header_buttons__edit-btn"
            >
              {BTN_TXT.EDIT_FEES}
            </Button>
          </div>
        )}
      </div>
      <Table<TCommunityProcessingItem>
        dataSource={tableData}
        pageSize={pageInfo.pageSize}
        pagination={{
          pageSize: pageInfo.pageSize,
          current: pageInfo.pageNumber,
          total: totalNumber
        }}
        className="split-fees-qsight"
        onChangePage={handleChangePageSize}
        onChange={handleTableChange}
        hasSearchOrFilters={isTableHasParams<TCommunityProcessingFilters>(
          '',
          filters
        )}
        rowSelection={{
          selectedRowKeys,
          onChange: handleSelectRow,
          hideSelectAll: true,
          renderCell: (checked, record, _, node) => {
            if (!checked && !selectedRowKeys.find((i) => i === record.uuid)) {
              return (
                <div className="row gap-12 align-baseline">
                  <Tooltip
                    title={TOOLTIP.ONLY_ONE_HEALTH_SYSTEM_CAN_BE_SELECTED}
                    overlayInnerStyle={{
                      display: 'block',
                      width: 254
                    }}
                    placement="topLeft"
                  >
                    {node}
                  </Tooltip>
                </div>
              )
            }
            return <div className="row gap-12 align-baseline">{node}</div>
          },
          getCheckboxProps: (record) => {
            const checkboxProps: CheckboxProps = {}
            if (
              !!selectedRowKeys.length &&
              !selectedRowKeys.find((i) => i === record.uuid)
            ) {
              checkboxProps.disabled = true
            }
            return checkboxProps
          }
        }}
      >
        <Column<TCommunityProcessingList>
          dataIndex="name"
          title={({ sortOrder, sortColumn }) => (
            <Sorter<TCommunityProcessingList>
              dataIndex="name"
              sortColumn={sortColumn}
              sortOrder={sortOrder as SortOrder}
            >
              Health System
            </Sorter>
          )}
          filterIcon={
            !!filters?.uuids?.length ? <FilterApplied16 /> : <Filter16 />
          }
          render={(name, record) => {
            return (
              <div
                className={cn('td-custom-class', {
                  'diff-cells': !!detectIfEmpty(record)
                })}
              >
                {name || '-'}
              </div>
            )
          }}
          filterDropdown={(props) => (
            <Dropdown.Filter<
              TCommunityProcessingFilters,
              TCommunityProcessingFiltersFunc,
              unknown
            >
              searchCallback={() => fetchHSListOptions(uuid)}
              applyFilters={applyFilters}
              appliedFilters={filters}
              field="uuids"
              optionFormatter={optionFormatter}
              asyncSearch
              {...props}
            />
          )}
          key="name"
          className="vertical-align-middle"
          sorter={true}
          showSorterTooltip={false}
        />
        <Column
          render={(rebate_fee) => rebate_fee || '-'}
          title="Rebate fee, %"
          className="vertical-align-middle"
          dataIndex="rebate_fee"
          key="rebate_fee"
        />
        <Column
          render={(admin_fee) => admin_fee || '-'}
          title="Admin fee, %"
          className="vertical-align-middle"
          dataIndex="admin_fee"
          key="admin_fee"
        />
        <Column
          title={
            <div className="row align-center gap-4">
              Contracting labor, %
              <Tooltip
                title={
                  'Fee paid by Health System when contracts are written on their behalf.'
                }
              >
                <InfoIcon />
              </Tooltip>
            </div>
          }
          render={(contracting_labor) => contracting_labor || '-'}
          className="vertical-align-middle"
          dataIndex="contracting_labor"
          key="contracting_labor"
        />
        <ColumnGroup
          className="col-with-border"
          title={
            <div className="row align-center justify-center gap-4">
              Marketplace AR{' '}
              <Tooltip
                title={
                  'Fee paid by Vendors (if Admin Fee is not being paid). A split can be shared with the Health System.'
                }
              >
                <InfoIcon />
              </Tooltip>
            </div>
          }
        >
          <Column
            title={'Vendor, %'}
            render={(marketplace_ar_vendor) => marketplace_ar_vendor || '-'}
            dataIndex="marketplace_ar_vendor"
            key="marketplace_ar_vendor"
          />
          <Column
            title={'HS Split, %'}
            render={(marketplace_ar_health_system_split) =>
              marketplace_ar_health_system_split || '-'
            }
            dataIndex="marketplace_ar_health_system_split"
            key="marketplace_ar_health_system_split"
            className="vertical-align-middle"
          />
        </ColumnGroup>
      </Table>
      {isEditOpen && !!selectedRows?.length && (
        <EditModal
          data={selectedRows[0]}
          open={isEditOpen}
          setOpen={setIsEditOpen}
          callbackFun={callback}
          community={uuid}
        />
      )}
    </div>
  )
}
